import React from 'react';

import { Column } from 'components/Layout/Grid';
import Text from 'components/Text';

import successImg from 'img/success-img.svg';

export const SchedulingSuccess: React.FC = () => {

  return (
    <Column className="bg-white w-100 flex-1 h-100 align-center justify-center" >
      <img src={successImg} alt="" />
      <Text className="color-blue-gray font-bold" size={18}>
        Agendamento realizado com sucesso
      </Text>
    </Column>
  );
};